import Slider from './slider';

const options = {
    navigation: {
        prevEl: '.js-product-slider-arrows-previous',
        nextEl: '.js-product-slider-arrows-next',
        disabledClass: 'product-slider-arrows__arrow--disabled',
    },
    slidesPerView: 1,
};

const slider = {
    init() {
        const elements = [...document.querySelectorAll('.js-product-slider')];
        elements.forEach((element) => {
            this.object = new Slider(element, options);
        });
    },
};

export default slider;
